import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styles';
import { Brush, Marker } from 'icons';
import { INft, TSizeType } from 'interfaces';

type TypeBadgeProps = {
  type: INft['creation_type'];
  size: TSizeType;
};

const TYPES: Record<
  number,
  {
    id: number;
    icon: ReactElement;
    label: string;
  }
> = {
  0: {
    id: 0,
    icon: <Brush />,
    label: 'nft.aIGenerated'
  },
  1: {
    id: 1,
    icon: <Marker />,
    label: 'nft.handDrawn'
  }
};

export const TypeBadge: FC<TypeBadgeProps> = ({ type, size = 'medium' }) => {
  const { t } = useTranslation();

  /*
   * This is a workaround for the fact that we don't have a type for the
   * generated ticket by seatmap (creation_type of NFT is 2)
   */
  if (type === undefined || type === null || type === 2) {
    return null;
  }

  return (
    <Styled.TypeBadgeWrapper $size={size}>
      {TYPES[type].icon}
      {size !== 'small' && t(TYPES[type].label)}
    </Styled.TypeBadgeWrapper>
  );
};
